import { KngFooterService, KngLoaderState } from 'kinetic-angular';
import { AfterViewInit, Component, EventEmitter, OnDestroy, OnInit, Output } from '@angular/core';
import { RolePermissionLabel } from './definitions';
import { RolesPermissionsService } from './roles-permissions.service';
import { Observable } from 'rxjs';
import { ComponentCanDeactivate } from '../../guards/pending-changes.guard.service';
import { ShellService } from '../shell/shell.service';
import { ConfirmLeavePageService } from '../../leave-page-confirm-popup/leave-page-confirm-popup.service';
import { LeaveConfirmModalState } from '../../services/shared/shared-interface';
import { RoutePermissions } from '../../guards/permission/definitions';
import { Icons } from '../../services/shared/shared-enums';

@Component({
	selector: 'tmhna-portal-roles-permissions',
	templateUrl: './template/roles-permissions.component.html',
	styleUrls: ['./template/roles-permissions.component.scss']
})
export class RolesPermissionsComponent implements OnInit, OnDestroy, ComponentCanDeactivate, AfterViewInit
{
	loaderState: KngLoaderState = {
    	imagePath: Icons.loaderWhite
	};

	@Output() leavePagestateChanged: EventEmitter<LeaveConfirmModalState> = new EventEmitter<LeaveConfirmModalState>();

	constructor(
    public service: RolesPermissionsService,
	private readonly leavePageService: ConfirmLeavePageService,
    private readonly footerService: KngFooterService,
	private readonly shellService: ShellService
	) {}

	ngOnInit(): void
	{
		this.service.isDirty = false;
		this.service.updateCopyRoleActiveStatus(false);
		this.service.getRolesPermissionsData();
		this.footerService.updateActionFooterPresent(true);
		this.service.initAnalyticsData();
	}
	ngOnDestroy(): void
	{
    	this.service.updateShell(false);
	}

	ngAfterViewInit(): void
	{
    	this.service.updateShell();
	}
	get labels(): RolePermissionLabel
	{
		return this.service.labels;
	}

	canDeactivate(): Observable<boolean> | boolean
	{
		this.shellService.isDirty$.next(this.service.isDirty);
		if(!this.service.isDirty)
		{
			this.shellService.shouldLoadPage$.next(true);
			return true;
		}
		else
		{
			this.shellService.shouldLoadPage$.next(false);
			return this.leavePageService.getModalSelectionObservable();
		}
	}

	saveChangesEvent(event: boolean)
	{
		this.service.isDirty = event;
	}

	get editPermissions(): RoutePermissions | undefined
	{
  	return this.service.getPermissions();
	}

}
